import { createBrowserRouter } from 'react-router-dom';
import { AuthShell } from '@/components/layout/auth-shell';
import { AppShell } from '@/components/layout/app-shell';
import { RedirectIfAuthed, RequireAuth } from '@/features/auth/require-auth';
import { LoginPage } from '@/features/auth/login-page';
import { RegisterTenantPage } from '@/features/auth/register-tenant-page';
import { ForgotPasswordPage } from '@/features/auth/forgot-password-page';
import { ResetPasswordPage } from '@/features/auth/reset-password-page';
import { AcceptInvitePage } from '@/features/auth/accept-invite-page';
import { DashboardPage } from '@/features/dashboard/dashboard-page';
import { UsersPage } from '@/features/users/users-page';
import { VehiclesPage } from '@/features/vehicles/vehicles-page';
import { VehicleDetailPage } from '@/features/vehicles/vehicle-detail-page';
import { DriversPage } from '@/features/drivers/drivers-page';
import { DriverDetailPage } from '@/features/drivers/driver-detail-page';
import { ChecklistsPage } from '@/features/checklists/checklists-page';
import { FuelingPage } from '@/features/fueling/fueling-page';
import { MaintenancePage } from '@/features/maintenance/maintenance-page';
import { NotificationsPage } from '@/features/notifications/notifications-page';
import { FinesPage } from '@/features/fines/fines-page';
import { AuditPage } from '@/features/audit/audit-page';
import { HelpPage } from '@/features/help/help-page';
import { SuppliersPage } from '@/features/suppliers/suppliers-page';
import { ProfilePage } from '@/features/profile/profile-page';
import { ReportsPage } from '@/features/reports/reports-page';
import { SettingsPage } from '@/features/settings/settings-page';
import { BillingPage } from '@/features/billing/billing-page';
import { LgpdPage } from '@/features/lgpd/lgpd-page';
import { LandingPage } from '@/features/landing/landing-page';
import { NotFoundPage } from '@/pages/not-found';

export const router = createBrowserRouter([
  // Landing de aquisição. Quem já tem sessão vai direto para o app — não faz
  // sentido mostrar a página de venda para quem já é cliente.
  {
    path: '/',
    element: (
      <RedirectIfAuthed>
        <LandingPage />
      </RedirectIfAuthed>
    ),
  },
  // Rotas públicas com layout de auth (2 painéis)
  {
    element: (
      <RedirectIfAuthed>
        <AuthShell />
      </RedirectIfAuthed>
    ),
    children: [
      { path: '/login', element: <LoginPage /> },
      { path: '/register', element: <RegisterTenantPage /> },
      { path: '/forgot-password', element: <ForgotPasswordPage /> },
      { path: '/reset-password', element: <ResetPasswordPage /> },
      { path: '/accept-invite', element: <AcceptInvitePage /> },
    ],
  },
  // Rotas autenticadas
  {
    element: <RequireAuth />,
    children: [
      {
        path: '/app',
        element: <AppShell />,
        children: [
          { index: true, element: <DashboardPage /> },
          { path: 'users', element: <UsersPage /> },
          { path: 'vehicles', element: <VehiclesPage /> },
          { path: 'vehicles/:id', element: <VehicleDetailPage /> },
          { path: 'drivers', element: <DriversPage /> },
          { path: 'drivers/:id', element: <DriverDetailPage /> },
          { path: 'suppliers', element: <SuppliersPage /> },
          { path: 'checklists', element: <ChecklistsPage /> },
          { path: 'fueling', element: <FuelingPage /> },
          { path: 'maintenance', element: <MaintenancePage /> },
          { path: 'fines', element: <FinesPage /> },
          { path: 'notifications', element: <NotificationsPage /> },
          { path: 'profile', element: <ProfilePage /> },
          { path: 'reports', element: <ReportsPage /> },
          { path: 'audit', element: <AuditPage /> },
          { path: 'billing', element: <BillingPage /> },
          { path: 'lgpd', element: <LgpdPage /> },
          { path: 'settings', element: <SettingsPage /> },
          { path: 'help', element: <HelpPage /> },
        ],
      },
    ],
  },
  { path: '*', element: <NotFoundPage /> },
]);
